<template>
  <div class="d-avatar" :class="[avatarClasses]" :style="{'height': size, 'width': size}">
    <div v-if="imgSrc" class="d-avatar--image">
      <img :src="imageSrc" :alt="altName">
    </div>
    <span v-else-if="text" class="d-avatar--text">
      {{ initials }}
    </span>
    <span v-else class="d-avatar--text">
      <d-icon icon="user" color="current" />
    </span>
  </div>
</template>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    props: {
      /**
       * Use a pre-defined color (`primary-500`, etc)
       */
      color: {
        type: String,
        default: 'primary-500',
      },

      /**
       * Up to two initials will be pulled from the text
       */
      text: {
        type: String,
        default: '',
      },

      /**
       * Image to show. This will take priority over text.
       */
      imgSrc: {
        type: String,
        default: '',
      },

      /**
       * Size. Include px/em/rem
       */
      size: {
        type: String,
        default: '32px',
      },
    },

    computed: {
      avatarClasses() {
        return {
          [`d-avatar--${this.color}`]: true,
        };
      },

      initials() {
        const words = this.text.split(' '); let
          initials = words[0].substring(0, 1).toUpperCase();

        if (words.length > 1) {
          initials += words[words.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
      },
    },
  });
</script>